import {z} from 'zod';

import {FinancialProductSelectionSchema} from './FinancialProductSelectionSchema';
import {FinancialProductTypeSchema} from './FinancialProductTypeSchema';
import {FinancingCellSchema} from './FinancingCellSchema';
import {LeasingCellSchema} from './LeasingCellSchema';
import {LeasingTargetGroupSchema} from './LeasingTargetGroupSchema';

export const FinancialProductOfferDimensionsSchema = z.object({
  productType: FinancialProductTypeSchema,
  providerName: z.string().nullable(),
  validFrom: z.string().nullable(),
  validTo: z.string().nullable(),
  availableTerms: z.array(z.number()),
  /** Requests between brackets use the lower bracket's rates. */
  availableDownPaymentPercentages: z.array(z.number()),
  downPaymentStep: z.number(),
  availableBalloonPaymentPercentages: z.array(z.number()),
  availableTargetGroups: z.array(LeasingTargetGroupSchema),
  availableLeasingCells: z.array(LeasingCellSchema),
  /**
   * Empty on leasing and on a contract snapshot. Optional until every backend publishes it; when
   * absent, controls fall back to the union lists above.
   */
  availableFinancingCells: z.array(FinancingCellSchema).optional(),
  selection: FinancialProductSelectionSchema.nullable(),
  /** The vehicle's configured default; optional until every backend publishes it. */
  defaultSelection: FinancialProductSelectionSchema.nullable().optional(),
});
export type FinancialProductOfferDimensions = z.infer<typeof FinancialProductOfferDimensionsSchema>;
